import { render } from "./nuevoPost.vue?vue&type=template&id=c4fbc3d8&scoped=true"
import script from "./nuevoPost.vue?vue&type=script&lang=js"
export * from "./nuevoPost.vue?vue&type=script&lang=js"

import "./nuevoPost.vue?vue&type=style&index=0&id=c4fbc3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fbc3d8"]])

export default __exports__